var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.specialsByPosition.length > 0)?_c('div',{staticClass:"df-space-y-4"},_vm._l((_vm.specialsByPosition),function(special){return _c('df-card-special',{key:special.uniqueId,attrs:{"promotion":_vm.promotion,"special":special}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }